import { Component, OnInit, DoCheck, HostBinding, HostListener, ElementRef } from '@angular/core';
import { NavService } from '../../services/nav-service';
import { IframeEmbedService } from '../../services/iframe-embed.service';
import { ScreenFullService } from '../../services/screenfull-service';
import { SidePanelService } from '../../services/side-panel-service';
import { sideWidth } from '../animations/animations.sidePanel';
import { environment } from '../../../../environments/environment';
import * as moment from 'moment';

@Component({
  selector: 'sk-content',
  templateUrl: './content.html',
  styleUrls: ['./content.scss'],
})
export class ContentComponent implements OnInit, DoCheck {

  @HostBinding('style.overflow-x') overflowX = 'hidden';
  @HostBinding('style.overflow-y') overflowY: string;

  footerEnabledTemp: boolean;

  constructor(
    public nav: NavService,
    private readonly iframeEmbed: IframeEmbedService,
    private readonly screenFull: ScreenFullService,
    private readonly sidePanel: SidePanelService,
    private readonly elementRef: ElementRef,
  ) {
  }

  get showChromeFooter(): boolean {
    return this.footerEnabledTemp && !this.iframeEmbed.isIframeEmbed;
  }

  ngOnInit() {
    this.nav.contentScrollTop = '0px';
  }

  get footerText() {
    const version = `v${environment.version}`;
    const envCode = environment.isProd ? ` ` : ` (${environment.envCode}) `;
    const year = moment().format('YYYY');
    return `&copy; ${year} ShopperKit${envCode} ${version} - All Rights Reserved.`;
  }

  // this solves the issue with value changed after checked (this was a persistent one)
  ngDoCheck() {
    // various hacks

    // console.log('checking', this.sidePanel.sideAnimationState1);
    if (this.nav.footerEnabled !== this.footerEnabledTemp) {
      this.footerEnabledTemp = this.nav.footerEnabled;
    }

    if (this.nav.contentIsScrollable) {
      this.overflowY = 'auto';
    } else {
      this.overflowY = 'hidden';
    }
    if (this.iframeEmbed.isIframeEmbed) {
      this.elementRef.nativeElement.style.setProperty('--var-offsetHeight', '0px');
      /* Fullscreen hides `sk-iframe-embed-header` (translateY); keep `top` in sync with measured stack / fallback. */
      const measured = this.nav.iframeEmbedHeaderStackPx;
      /* When main embed row is hidden, do not use default chrome height as fallback. */
      const fallback = this.nav.iframeEmbedToolbarSuppressed
        ? 0
        : this.iframeEmbed.embedToolbarChromePx +
          this.nav.offsetTop -
          this.iframeEmbed.iframeMainContentTopPullUpPx;
      const raw = measured > 0 ? measured : fallback;
      const topPx = this.screenFull.isFullscreen ? 0 : Math.max(0, raw);
      this.elementRef.nativeElement.style.top = `${topPx}px`;
    } else {
      this.elementRef.nativeElement.style.removeProperty('top');
      this.elementRef.nativeElement.style.setProperty('--var-offsetHeight', `${this.nav.offsetTop}px`);
    }
    /*
     * Keep `sk-content` `right` in sync with `sideWidth()` when the filter rail is open (animation can drift).
     */
    if (this.sidePanel.sideAnimationState === 'in') {
      this.elementRef.nativeElement.style.setProperty('right', sideWidth());
    } else {
      this.elementRef.nativeElement.style.removeProperty('right');
    }
  }

  @HostListener('scroll', ['$event'])
  setScrollTop(event: any) {
    const scrollTop = event.target.scrollTop + 'px';
    this.nav.contentScrollTop = scrollTop;
  }
}
